import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

/**
 * React Query key for the uninstall cascade preview. The detail page's
 * confirmation dialog enables the query only when the dialog opens —
 * otherwise the server walks the dependency graph for nothing.
 */
export function orgPluginUninstallPreviewQueryKey(organizationId: string, pluginName: string) {
  return ['org-plugin-uninstall-preview', organizationId, pluginName] as const;
}

export function useOrgPluginUninstallPreview(
  organizationId: string | null | undefined,
  pluginName: string | null | undefined,
  opts: { enabled?: boolean } = {},
) {
  return useQuery({
    queryKey: orgPluginUninstallPreviewQueryKey(organizationId ?? '', pluginName ?? ''),
    queryFn: () => api.getOrgPluginUninstallPreview(organizationId!, pluginName!),
    enabled: !!organizationId && !!pluginName && (opts.enabled ?? true),
  });
}
